import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { styled, Grid, Col, Row, up, css } from '@smooth-ui/core-sc';
import RexelLogo from './images/Rexel-Logo@2x.png';
import JRTLogo from './images/JohnRTurk-Logo@2x.png';
import IdealLogo from './images/ideal-Logo@2x.png';
import LSLogo from './images/LearSmith-Logo@2x.png';

import JRTLogoOnWhite from './images/Login-JohnRTurk-Logo@2x.png';
import IdealLogoOnWhite from './images/Login-ideal-Logo@2x.png';
import LSLogoOnWhite from './images/Login-LearSmith-Logo@2x.png';

import { withSettings } from 'containers/WebApp/SettingsContext';

const BannerContainer = styled.div`
  margin: 10px 0 20px;

  ${up(
    'sm',
    css`
      margin: 1em;
    `
  )}

  .align__logo {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 80%;
    height: auto;
    max-width: 150px;
    margin: 10px 0;

    &.turk__logo {
      max-width: none;
    }
  }
`;

const RexelBanners = props => (
  <BannerContainer>
    <Grid>
      <Row justifyContent="center">
        <Col xs={12}>
          <Grid>
            <Row justifyContent="center">
              <Col xs={6} sm={3} className="align__logo">
                <img alt="Rexel" src={RexelLogo} />
              </Col>
              <Col xs={6} sm={3} className="align__logo">
                <img
                  alt="Ideal"
                  src={props.onWhite ? IdealLogoOnWhite : IdealLogo}
                />
              </Col>
              <Col xs={6} sm={3} className="align__logo">
                <img
                  alt="Lear &amp; Smith"
                  src={props.onWhite ? LSLogoOnWhite : LSLogo}
                />
              </Col>
              <Col xs={6} sm={3} className="align__logo">
                <img
                  alt="John R. Turk"
                  src={props.onWhite ? JRTLogoOnWhite : JRTLogo}
                  className="turk__logo"
                />
              </Col>
            </Row>
          </Grid>
        </Col>
      </Row>
    </Grid>
  </BannerContainer>
);

RexelBanners.propTypes = {
  onWhite: PropTypes.bool,
};

RexelBanners.defaultProps = {
  onWhite: false,
};

export default withSettings(RexelBanners);
